import React from 'react';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext } from 'components/Managers/Dashboard/Context';
import useTopics from 'components/Managers/Dashboard/Hooks/useTopics';
import TopicItem from './TopicItem';
import TopicsList from './TopicsList';

export default function Modules() {
  const { state: { filters } } = useContext();
  const { data: topics, loading } = useTopics(filters);

  return (
    <div className="h-100 border border-2 rounded-3 p-3">
      <h5 className="mb-4">Modules</h5>

      {loading ? <LoadingPlaceholder className="mb-3" /> : (
        <>
          {topics && topics.slice(0, 3).map((topic) => <TopicItem key={topic.id} topic={topic} />)}
          <TopicsList topics={topics} />
        </>
      )}
    </div>
  );
}
